import RequestUserCode from 'gcs-common/components/RequestUserCode/RequestUserCode';
import UserCodeWebWrapper from '../UserCodeWebWrapper';

const RequestUserCodeWeb = () => {
  return (
    <UserCodeWebWrapper>
      <RequestUserCode />
    </UserCodeWebWrapper>
  );
};

export default RequestUserCodeWeb;
